import { defineStore } from "pinia";
import { onMounted, onBeforeMount, reactive, ref, toRefs } from "vue";
// import {
// 	useTcpSocketFn
// } from "./useTcpSocket.js"
import { useWebSocketFn } from "./Fn/useWebSocket.js";

// import { useSocketFn } from "./Fn/useSocket.js";

const useTcpSocketStore = defineStore("tcpSocket", () => {
  const {
  	initSocket,
  	monitorMessages,//监听消息
  	sendSocketData, //发送信息
  	activeCloseSocket, //主动关闭
    webSocketIndex,
  } = useWebSocketFn()

//   const {
//     initSocket,
//     monitorMessages, //监听消息
//     sendSocketData, //发送信息
//     activeCloseSocket, //主动关闭
//   } = useSocketFn();

  return {
    initSocket,
    monitorMessages, //监听消息
    sendSocketData, //发送信息
    activeCloseSocket, //主动关闭
    webSocketIndex,
  };
});

export default useTcpSocketStore;
